import gql from 'graphql-tag'

export const GET_STEP_LIST = gql`
  query GetSteps {
    steps {
      id
      stepType {
        id
        name
      }
      name
      needTool
    }
    stepTypes {
      id
      name
    }
  }
`

export const GET_STEP_BY_ID = gql`
  query GetStepById($id: Int!) {
    step(id: $id) {
      id
      stepType {
        id
        name
      }
      name
      needTool
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/Step.js